import React, { useCallback, useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import {
    isBackendDown,
    subscribeBackendStatus,
    reportBackendResponse,
    reportBackendUnreachable,
} from "common/backendStatus";
import config from "../config";

// Shown while the API is unreachable — almost always a backend deploy. Without it the
// screens just fail silently or throw error toasts, and the branch assumes the system
// is broken.
//
// On the POS till it is a banner rather than a full overlay: blocking the screen there
// would strand an operator mid-sale with a basket they cannot save. Everywhere else the
// overlay is the honest answer, since nothing on the page can work anyway.
const PROBE_INTERVAL_MS = 10000;

const isTill = () => window.location.pathname.startsWith("/admin/pos");

function MaintenanceNotice() {
    const [down, setDown] = useState(isBackendDown());

    useEffect(() => subscribeBackendStatus(setDown), []);

    // While down, keep knocking so the notice clears itself when the deploy finishes.
    // A cheap public endpoint is enough: we only care that something answers.
    const probe = useCallback(async () => {
        try {
            const response = await fetch(`${config.WS_BASE_URL}app/params/primary`, {
                cache: "no-store",
                headers: {
                    Country: localStorage.getItem("selectedCountry") || "1",
                    "X-Tenant-Key": localStorage.getItem("tenantId") || "main",
                },
            });
            reportBackendResponse(response.status);
        } catch (error) {
            reportBackendUnreachable();
        }
    }, []);

    useEffect(() => {
        if (!down) return undefined;
        const timer = setInterval(probe, PROBE_INTERVAL_MS);
        return () => clearInterval(timer);
    }, [down, probe]);

    if (!down) return null;

    const message = "Updating the system — this usually takes a minute. This page will continue on its own.";

    if (isTill()) {
        return (
            <Box
                style={{
                    position: "fixed", top: 0, left: 0, right: 0, zIndex: 2100,
                    display: "flex", alignItems: "center", justifyContent: "center", gap: 12,
                    padding: "10px 16px", background: "#fb6340", color: "#fff",
                }}
            >
                <CircularProgress size={16} style={{ color: "#fff" }} />
                <Typography variant="body2" style={{ color: "#fff", fontWeight: 600 }}>
                    {message}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            style={{
                position: "fixed", inset: 0, zIndex: 2100,
                display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                gap: 18, background: "rgba(20, 22, 46, 0.94)", color: "#fff", textAlign: "center", padding: 24,
            }}
        >
            <CircularProgress style={{ color: "#fff" }} />
            <Typography variant="h5" style={{ color: "#fff", fontWeight: 700 }}>
                System update in progress
            </Typography>
            <Typography variant="body2" style={{ color: "#d6d8e5", maxWidth: 420 }}>
                {message}
            </Typography>
        </Box>
    );
}

export default MaintenanceNotice;
